import styled from "styled-components";
export const OrderContainer = styled.section`
  .order {
    border-radius: 10px;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.19);
    margin: 20px 0;
    margin-top: 0;
    overflow: hidden;
    padding: 16px;
    background-color:#fff;
    .steps {
      margin: 32px 0px;
      display: flex;
      justify-content: space-between;
      position: relative;
      flex-wrap: wrap;
      .line {
        position: absolute;
        height: 1px;
        width: 100%;
        top: calc(50% - 1px);
        background: #ccc;
      }
      .step {
        position: relative;
        background: #fff;
        font-size: 13px;
        padding: 4px;
        display: flex;
        color: #999;
        span {
          margin-left: 4px;
          font-size: 14px;
        }
      }
      .active {
        color: #ca6a44;
        span {
          background: #ca6a44;
          border-radius: 100%;
          color: #fff;
          display: inline-flex;
          width: 16px;
          height: 16px;
          justify-content: center;
          align-items: center;
        }
      }
      @media only screen and (max-width: 760px) {
        justify-content: start;
        .line {
          display: none;
        }
        .step {
          padding-left: 8px;
          &:after {
            position: absolute;
            left: 0px;
            content: "/";
          }
          &:last-child {
            padding-left: 0;
            &:after {
              content: "";
            }
          }
        }
      }
    }
    .title-area,
    .bottom-area {
      weight: 100%;
      display: flex;
      justify-content: space-between;
      .order-title {
        font-weight: bold;
      }
      .order-date {
        font-size: 14px;
      }
      .invoice-status {
        display: flex;
        align-items: center;
        gap: 8px;
        .order-status {
          font-size: 14px;
        }
      }
    }
    .options {
      width: 100%;
      padding-top: 16px;
      button {
        width: 100%;
      }
    }
    .notife {
      font-size: 12px;
      padding-top: 8px ;

    }
    @media only screen and (max-width: 760px) {
      .title-area {
        display: block;
        .order-date {
          width: 100%;
          text-align: left;
        }
      }
    }
  }
  .modal-body {
    .buttons {
      display: flex;
      justify-content: space-between;
    }
  }
`;
export const ColorSelectorContainer = styled.section`
  margin-bottom: 32px;
  .item {
    background-color: #dce5e5;
    margin: 4px 0;
    padding: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 3px;
    cursor: pointer;
    .title-area {
      display: flex;
      align-items: center;
      .color {
        margin-left: 16px;
        width: 32px;
        height: 32px;
        border-radius: 42px;
        box-shadow: 0 0 5px rgb(0 0 0 / 20%);
        display: inline-block;
      }
    }
    &:hover {
      background-color: #005f3b;
      color: #fff;
    }
  }
  .selected {
    background-color: #005f3b;
    color: #fff;
  }
  @media only screen and (max-width: 760px) {
    padding: 16px 8px;
  }
`;
